
<script>
	function Logout(){
		window.location.href = "/logout";
	}
</script>

<style>

h1 {
	margin-top: 0px;
	margin-bottom: -5px;
	font-size: 40px;
	background: -webkit-linear-gradient(rgb(0, 176, 240),rgb(0, 104, 177));
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	padding: 0px;

}
h2 {
	margin-top: 0px;
	margin-bottom: 5px;
	font-size: 20px;
	padding: 0px;
}
h3 {
	margin-top: 0px;
	margin-bottom: 5px;
	font-size: 15px;
	padding: 0px;
}
.blue-fade{
	font-family: Tahoma, Geneva, sans-serif;
	/* font-style: italic; */
	font-weight: bold;
	background: -webkit-linear-gradient(rgb(0, 176, 240),rgb(0, 104, 177));
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

table{
	border-collapse: collapse;
	width: 100%;
	font-family: monospace;
	text-align: center;
	margin-top: 0px;
	margin-bottom: 0px;
}

.Cell1{
	text-align: right;
	width: 45%;
	/* border-width: 0.1ch;
	border-color: white; */
}
.Cell2{
	text-align: left;
	/* border-width: 0.1ch;
	border-color: white; */
}
.Cell3{
	text-align: right;
    padding: 10px;
	/* border-width: 0.1ch;
	border-color: white; */
}

td{
	margin: 0px;
	padding: 0px;
}
tr{
	margin: 0px;
	padding: 0px;
}
table{
	margin: 0px;
	padding: 0px;
}

.navbar{
	margin: 0px;
	padding: 0px;	
}

@media screen and (max-width: 600px) {
	h1 {
		margin-top: 0px;
		margin-bottom: 4px;
		font-size: 35px;
	}
	h2 {
		margin-top: 0px;
		margin-bottom: 4px;
		font-size: 15px;
	}
	h3 {
		margin-top: 0px;
		margin-bottom: 2px;
		font-size: 12px;
	}
	.Cell1{
		width: 25%;
	}
}
</style>

<nav class="navbar navbar-expand navbar-dark fixed-top bg-dark m-2">
	<table>
		<tr>
			<td class="Cell1">
				<img src="/images/VMS_Transparent.png" width="100" height="72" alt="">	
			</td>
			<td class="Cell2">
				<h1 class="blue-fade">Real-time</h1>
				<h2 class="blue-fade">Environmental Monitoring</h2>
			</td>
            <td class="Cell3">
				<h1 class="blue-fade">&nbsp;</h1> 
				<!-- <h3 class="blue-fade"><a href="#/" on:click={Logout}>Logout</a></h3> -->
			</td>
		</tr>
	</table>
</nav>